import GeometryProvider from './geometryProvider';

export const getGeometryPreviewAsync = GeometryProvider.getGeometryPreviewAsync;

export const getGeometryByIdAsync = GeometryProvider.getGeometryByIdAsync;

export const updateGeometryAsync = GeometryProvider.updateGeometryAsync;

export const updateGeometryWithMaterialsAsync = GeometryProvider.updateGeometryWithMaterialsAsync;

export const InsertGeometryAsync = GeometryProvider.InsertGeometryAsync;

export const getAllGeometryPreviewAsync = GeometryProvider.getAllGeometryPreviewAsync;
